import { css } from '@mui/material/styles';
export const progressIndicatorsComponentOverrides = {
    MuiLinearProgress: {
        defaultProps: {
            color: 'primary',
            variant: 'indeterminate'
        },
        styleOverrides: {
            root: () => css `
                height: 0.25rem;

                &[data-fuel-size='small'] {
                    height: 0.125rem;
                }

                &[data-fuel-size='large'] {
                    height: 0.5rem;
                }
            `
        }
    },
    MuiCircularProgress: {
        defaultProps: {
            color: 'primary',
            variant: 'indeterminate'
        },
        styleOverrides: {
            root: ({ theme }) => css `
                height: ${theme.tokens.FuelSpacing8} !important;
                width: ${theme.tokens.FuelSpacing8} !important;
                stroke-width: 4px;

                &[data-fuel-size='small'] {
                    height: ${theme.tokens.FuelSpacing4} !important;
                    width: ${theme.tokens.FuelSpacing4} !important;
                    stroke-width: 5px;
                }

                &[data-fuel-size='large'] {
                    height: ${theme.tokens.FuelSpacing12} !important;
                    width: ${theme.tokens.FuelSpacing12} !important;
                    stroke-width: 3px;
                }
            `
        }
    }
};
